import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IBaseResponse, IConnectToDonorStatus, IDonorConnectCounts, IDonorConnectIldaUploadedFile, IListItem, IDashRegistrationLog, IDonorConnect, IDonorConnectUser } from '@nkr/models/index';
import { IPost, IDelete } from '../authorization/actions';
import { ICounselor } from '@nkr/views/dash/donor-connect/models';

export interface IIldaListResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            list: IDonorConnect[],
            counts: IDonorConnectCounts
        }
    }
}

export interface IIldaCountResponse {
    data: {
        success: boolean,
        message: string,
        results: IDonorConnectCounts
    }
}

export interface IIldaRegistrationResponse {
    data: {
        success: boolean,
        message: string,
        results: IDonorConnect
    }
}

export interface IIldaLogListResponse {
    data: {
        success: boolean,
        message: string,
        results: IDashRegistrationLog[]
    }
}

export interface IIldaUploadedFilesListResponse {
    data: {
        success: boolean,
        message: string,
        results: IDonorConnectIldaUploadedFile[]
    }
}

export interface IIldaLogResponse {
    data: {
        success: boolean,
        message: string,
        results: IDashRegistrationLog
    }
}

export interface IIldaLookupDataResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            statusList: IConnectToDonorStatus[],
            actionList: IListItem[],
            userList: ICounselor[]
        }
    }
}

export interface IIldaUserListResponse {
    data: {
        success: boolean,
        message: string,
        results: IDonorConnectUser[]
    }
}

export const ActionCreators = {
    getIldaUsers: () => async (dispatch: Dispatch<IApplicationState>): Promise<IIldaUserListResponse> => {
        let options = {
            url: `${__API__}/donor-connect/ilda/users`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getIldaList: (listType: number, counselorFilter: number, statusFilter: number, showFilter: number, searchFilter: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IIldaListResponse> => {
        let options = {
            url: `${__API__}/donor-connect/ilda/registrations?listType=${listType}&counselor=${counselorFilter}&status=${statusFilter}&show=${showFilter}&search=${searchFilter}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getIldaCounts: () => async (dispatch: Dispatch<IApplicationState>): Promise<IIldaCountResponse> => {
        let options = {
            url: `${__API__}/donor-connect/ilda/counts`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getIldaLookupData: () => async (dispatch: Dispatch<IApplicationState>): Promise<IIldaLookupDataResponse> => {
        let options = {
            url: `${__API__}/donor-connect/ilda/lookup-data`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getIldaRegistration: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IIldaRegistrationResponse> => {
        let options = {
            url: `${__API__}/donor-connect/ilda/registration/${id}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getIldaLogEntries: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IIldaLogListResponse> => {
        let options = {
            url: `${__API__}/donor-connect/ilda/registration/${id}/logs`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getUploadedFilesList: (registrationid: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IIldaUploadedFilesListResponse> => {
        let options = {
            url: `${__API__}/donor-connect/ilda/${registrationid}/uploaded-files`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    changeIldaStatus: (id: number, status: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/ilda/${id}/change-status/${status}`
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    changedIldaAssignedCounselor: (id: number, userId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/ilda/${id}/assigned-counselor/${userId}`
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },

    unassignIldaCounselor: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/ilda/${id}/unassign-counselor`
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },

    updateIldaNextFollowUpDate: (id: number, date: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/ilda/${id}/next-followup-date?date=${date}`
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    uploadIldaFile: (registrationid: number, ildaFile: File, description: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let formData = new FormData();

        formData.append('ildaFile', ildaFile);
        formData.append('description', description);

        let config: IPost = {
            url: `${__API__}/donor-connect/ilda/${registrationid}/upload`,
            data: formData
        };

        return await dispatch(AuthActionCreators.apiPostFormData(config)).then((response: IBaseResponse) => {
            return response;
        });
    },
    updateIldaCaseLoad: (userId: number, donorConnectCaseLoad: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/donor-connect/ilda/case-load`,
            data: {
                userId,
                donorConnectCaseLoad
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    saveIldaLogEntry: (id: number, dashRegistrationId: number, actionTakenId: number, comments: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IIldaLogResponse> => {
        let options: IPost = {
            url: `${__API__}/donor-connect/ilda/log-entry`,
            data: {
                id,
                dashRegistrationId,
                actionTakenId,
                comments
            }
        };

        try {
            if (id == 0)
                return await dispatch(AuthActionCreators.apiPost(options));
            else
                return await dispatch(AuthActionCreators.apiPut(options));
        } catch (error) {
            throw error;
        }
    },
    deleteIldaLogEntry: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IDelete = {
            url: `${__API__}/donor-connect/ilda/log-entry/${id}`
        };

        try {
            return await dispatch(AuthActionCreators.apiDelete(options));
        } catch (error) {
            throw error;
        }
    },
}